import { useEffect } from "react";

const useTitle = (title) => {
  useEffect(() => {
    let defaultTitle = "Agency Connect";
    document.title = title ? title : defaultTitle;
  }, [title]);
};

export default useTitle;
